import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    displayName:'',
    alternativeID:''
  },
  getters: {
  },
  mutations: {
    ['setDisplayName'](state, displayName){
      sessionStorage.setItem("displayName", displayName);
      state.displayName = displayName;
    },
    ['setUserID'](state, alternativeID){
      sessionStorage.setItem("alternativeID", alternativeID);
      state.alternativeID = alternativeID;
    }
  },
  actions: {
  },
  modules: {
  },
});
